import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, desc, dark = false, testid }) => (
  <Reveal>
    <div className="max-w-2xl">
      {eyebrow && (
        <p className="flex items-center gap-3 font-display text-xs font-bold uppercase tracking-[0.28em] text-brand">
          <span className="h-px w-8 bg-brand" aria-hidden="true" />
          {eyebrow}
        </p>
      )}
      <h2
        data-testid={testid}
        className={`mt-4 font-display text-3xl font-extrabold uppercase tracking-tight sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-ink-900"}`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-4 text-base leading-relaxed md:text-lg ${dark ? "text-white/60" : "text-neutral-500"}`}>
          {desc}
        </p>
      )}
    </div>
  </Reveal>
);
